import React from "react";
import Modal from "components/ui/modal";
import AskForTextConsent from "./ask-for-text-consent";
import propTypes from "prop-types"
import useTranslate from "hooks/use-translate-language";


const AskForTextConsentModal = ({ phone_number }) => {
    const translate = useTranslate();

    return <div>
        <Modal
            maxWidth="xs"
            fullWidth
            renderTrigger={() => null}
            startOpen={true}
            aria-label={translate("textConsentModal")}
            renderContent={({ closeModal }) => (<AskForTextConsent phone_number={phone_number} closeDialog={closeModal} />)}
        />
    </div>
}

AskForTextConsentModal.propTypes = {
    phone_number: propTypes.string
}

export default AskForTextConsentModal;
